
    import {Component, Mixins, Vue} from 'vue-property-decorator'
    import LoginPreview from '@/pages/Login/LoginPreview.vue'
    import loginGirl from '@/assets/backgrounds/login-girl.png'
    import LoginOptionsWrapper from '@/pages/Login/LoginOptionsWrapper.vue'
    import {AdaptiveMixin} from '@/mixins/AdaptiveMixin'

    @Component({
        components: {LoginOptionsWrapper, LoginPreview},
    })
    export default class LoginPage extends Mixins<AdaptiveMixin>(AdaptiveMixin) {
        get loginGirl() {
            return loginGirl
        }

        get titleText() {
            return ['Achieve More', 'with Chat AI']
        }

        get descriptionText() {
            return 'Unlock the full potential of Chat AI.'
        }
    }
